module.exports = __webpack_public_path__ + "img/save-img.e29c7476.png";